/* import __COLOCATED_TEMPLATE__ from './line-item-help-icon.hbs'; */
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { SUPPORT } from '../constants/links';

export default Component.extend({
  session: service(),

  /**
   * HTML Component properties
   */
  tagName: 'span',

  /*********************************
   * REQUIRED PARAMS
   **********************************/

  /**
   * @param {String} type The type of line item (base|select).
   */
  type: '',

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  /**
   * @param {Number} feePercentage The fee as a percentage.
   */
  feePercentage: null,

  /*********************************
   * PRIVATE
   **********************************/

  /**
   * @type {String} The body text of the tooltip.
   */
  _bodyText: computed('type', function () {
    if (this.get('type') === 'base') {
      return 'Based on your revenue with this client.';
    }

    if (this.get('type') === 'select') {
      return `${this.get('feePercentage') * 100}% for Select projects.`;
    }

    return '';
  }),

  /**
   * @type {String} The URL of the help page.
   */
  _helpLink: computed('session.currentUser.isBuyer', 'type', function () {
    if (this.get('type') === 'base') {
      return SUPPORT.SELLER_FEES;
    }

    if (this.get('type') === 'select') {
      return this.get('session.currentUser.isBuyer')
        ? SUPPORT.SELECT_FOR_BUYERS
        : SUPPORT.SELECT_FOR_SELLERS;
    }

    return '';
  }),
});
